/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_hub_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 is what percent of 80? (12 ÷ 80) × 100 = 15%.`)
};

const es_pct_hub_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué porcentaje de 80 es 12? (12 ÷ 80) × 100 = 15%.`)
};

const de_pct_hub_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 sind wie viel Prozent von 80? (12 ÷ 80) × 100 = 15 %.`)
};

const nl_pct_hub_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 is welk percentage van 80? (12 ÷ 80) × 100 = 15%.`)
};

const fr_pct_hub_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 représente quel pourcentage de 80 ? (12 ÷ 80) × 100 = 15 %.`)
};

const it_pct_hub_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 è quale percentuale di 80? (12 ÷ 80) × 100 = 15%.`)
};

const pt_br2_pct_hub_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 é que porcentagem de 80? (12 ÷ 80) × 100 = 15%.`)
};

const pt_pct_hub_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 é que percentagem de 80? (12 ÷ 80) × 100 = 15%.`)
};

const ja_pct_hub_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12は80の何パーセント？ (12 ÷ 80) × 100 = 15%。`)
};

const zh_pct_hub_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 是 80 的百分之几？(12 ÷ 80) × 100 = 15%。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_hub_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_hub_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_hub_ex2", locale)
	if (locale === "en") return en_pct_hub_ex2(inputs)
	if (locale === "es") return es_pct_hub_ex2(inputs)
	if (locale === "de") return de_pct_hub_ex2(inputs)
	if (locale === "nl") return nl_pct_hub_ex2(inputs)
	if (locale === "fr") return fr_pct_hub_ex2(inputs)
	if (locale === "it") return it_pct_hub_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_pct_hub_ex2(inputs)
	if (locale === "pt") return pt_pct_hub_ex2(inputs)
	if (locale === "ja") return ja_pct_hub_ex2(inputs)
	return zh_pct_hub_ex2(inputs)
};